import React from 'react';
import { compose } from 'redux';
import { FormattedMessage } from 'translations';
import MobileScreen from 'app/components/base/MobileScreen';
import { connectSubpages } from 'app/hocs/subpageManagable';
import PriceBreakdown from 'app/components/book-trip/PriceBreakdown';
import { BOOK_TRIP_FORM } from 'app/constants';
import { getFormComponent } from 'app/utils/form';


const messages = {
  title: { id: 'BOOK_TRIP.TRIP_DETAILS' }
};

/**
 * Component that embeds the price breakdown in a mobile screen
 */
export class PriceBreakdownScreen extends React.Component {
  static defaultProps = {
    showTotalPrice: true
  }

  handleClickBack = () => {
    this.props.subpages.popPage();
  }

  render() {
    const { readOnly, showTotalPrice, formName = BOOK_TRIP_FORM } = this.props;
    const Form = getFormComponent(formName);

    return (
      <MobileScreen
        title={<FormattedMessage {...messages.title} />}
        onClickBack={this.handleClickBack}
      >
        <Form>
          <PriceBreakdown 
            mobile 
            readOnly={readOnly} 
            formName={formName} 
            showTotalPrice={showTotalPrice}  
          />
        </Form>
      </MobileScreen>
    );
  }
}

// TODO: move to Flow types
// PriceBreakdownScreen.propTypes = {
//   subpages: PropTypes.object.isRequired,
//   formName: PropTypes.string,
//   readOnly: PropTypes.bool
// };

export default compose(
  connectSubpages()
)(PriceBreakdownScreen);
